export const TRACKING_STORAGE_KEY = 'ga_t_consent';
